import { render, staticRenderFns } from "./MailingUnsubscribe.vue?vue&type=template&id=5a736189"
import script from "./MailingUnsubscribe.vue?vue&type=script&lang=js"
export * from "./MailingUnsubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports